export default "/images/ISO_Logo.png";